import {combineReducers} from 'redux';
import {reducer as detailReducer} from './detail';
import {reducer as vehiclesReducer} from './vehicles';

export const reducer = combineReducers({
    detail: detailReducer,
    vehicles: vehiclesReducer,
});

